/**
 * Created by lari on 09/06/2017.
 */
(function () {
  'use strict';
  
  /* @ngdoc object
   * @name consult
   * @description
   *
   */
  angular
    .module('vcconsult', [
      'ui.router',
      'ui.bootstrap',
      'vcclient',
      // 'drug',
      // 'document',
      'vcfinance.cart',
      'vcexam',
      'vcexamtemplate',
      'vcpatdocs',
      'vcdrug',
      'knalli.angular-vertxbus',
      'cfp.hotkeys',
      'vcutils.doctor',
      'vcutils.rlog',
      'vcutils.sprhelp',
      'vcutils.printhelper',
      'vcdms',
      'vcdms.vcfile'
    ]);
  
}());
